import { Component, Input } from '@angular/core';
import { ChallengeTime, TimeTotal } from 'src/app/interfaces/time';
import { DUMMY_DONUT_GRAPH_OPTIONS } from 'src/app/shared/data/data';

@Component({
  selector: 'app-challenge-time',
  templateUrl: './challenge-time.component.html',
  styleUrls: ['./challenge-time.component.scss'],
})
export class ChallengeTimeComponent {
  @Input()
  challengesTime?: ChallengeTime[] = [];

  @Input()
  averageActivity?: TimeTotal;

  @Input()
  averageChallenge?: TimeTotal;

  @Input()
  averageTotal?: TimeTotal;

  optionsGraph: any = DUMMY_DONUT_GRAPH_OPTIONS;
  colors: string[] = ['#414E9C', '#3C7773', '#F7503E', '#FEBB39'];

  timeNumber(time?: TimeTotal) {
    if (!time) return 0;

    if (time.days > 0) return time.days;
    if (time.hours > 0) return time.hours;
    return Math.floor(time.minutes);
  }

  timeText(time?: TimeTotal) {
    if (!time) return 'CHALLENGES.minutes';

    if (time.days > 0) return 'CHALLENGES.days';
    if (time.hours > 0) return 'CHALLENGES.hours';
    return 'CHALLENGES.minutes';
  }

  timeUnit(time?: TimeTotal) {
    if (!time) return 'm';

    if (time.days > 0) return 'd';
    if (time.hours > 0) return 'h';
    return 'm';
  }
}
